const POSITIVE_VIEWER_MEASUREMENT_FIELDS = [
  "viewer_count",
  "peak_viewer_count",
  "first_viewer_count",
  "last_viewer_count",
];

export const STREAMING_PLAYBACK_REPORT_COPY = Object.freeze({
  sectionTitle: "Observação de reprodução",
  sectionDescription: "Usa somente a telemetria validada dos players. Conexões à página continuam sendo uma métrica separada e não são usadas como substituto de reprodução.",
  activePeakTitle: "Pico de reprodução ativa",
  activePeakDetail: "Maior quantidade observada no mesmo intervalo.",
  backgroundPeakTitle: "Pico em segundo plano",
  backgroundPeakDetail: "Reprodução ativa enquanto a aba estava oculta.",
  coverageTitle: "Cobertura da telemetria",
  coverageUnknown: "não medida",
  lastQualifiedTitle: "Última observação qualificada",
  playersUnit: "players",
  qualifiedObservationsSuffix: "observações de players qualificadas.",
  samplesProcessedSuffix: "amostras processadas.",
  activeSeriesLabel: "Reprodução ativa",
  backgroundSeriesLabel: "Reprodução em segundo plano",
  chartYAxisTitle: "Players em reprodução",
  chartAriaLabel: "Gráfico de reprodução ativa e em segundo plano",
  chartEmpty: "Os totais foram validados, mas não há pontos temporais disponíveis para este período.",
  chartFootnote: "Cada ponto representa o maior valor observado no intervalo. Os picos de reprodução ativa e em segundo plano podem ter ocorrido em instantes diferentes.",
  unavailableTitle: "Dados de reprodução indisponíveis.",
  unavailableCoveragePrefix: "Cobertura observada:",
  availableInterpretation: "Reprodução ativa considera players com telemetria recente de reprodução efetiva. Reprodução em segundo plano é a parcela ativa com a aba oculta. Os valores do gráfico são picos por intervalo e não substituem as métricas de conexão.",
  unavailableInterpretation: "Os números históricos de reprodução só aparecem quando cada intervalo medido com público tem cobertura qualificada de telemetria. Intervalos posteriores sem público não invalidam medições anteriores.",
  pdfScope: "Visão geral, indicadores, programação, engajamento, reprodução, identificação, conexões, reações, enquetes e guia. Participantes conectados e atividades operacionais não fazem parte deste PDF.",
  coverageMessages: Object.freeze({
    absent: "Ainda não há observações qualificadas de telemetria de reprodução para esta execução.",
    partial: "A cobertura da telemetria foi parcial. Os números de reprodução permanecem ocultos para evitar uma leitura incompleta.",
    stale: "Após a última observação qualificada, houve intervalos com público sem cobertura de telemetria. Os números de reprodução permanecem ocultos.",
    unavailable: "A telemetria de reprodução não está disponível com cobertura suficiente para esta execução.",
  }),
});

export const resolveStreamingPlaybackCoverageMessage = (coverageStatus) => (
  STREAMING_PLAYBACK_REPORT_COPY.coverageMessages[String(coverageStatus || "").toLowerCase()]
  || STREAMING_PLAYBACK_REPORT_COPY.coverageMessages.unavailable
);

const textValue = (value, fallback) => {
  const normalized = String(value || "").trim();
  return normalized || fallback;
};

export const shouldCommitStreamingReportRequest = ({
  activeRequestId,
  requestId,
  activeRequestSource,
  requestSource,
} = {}) => (
  activeRequestId === requestId && activeRequestSource === requestSource
);

export const resolveStreamingViewerMeasurementStatus = (dataQuality = {}, viewerRows = []) => {
  if (String(dataQuality?.viewer_interval?.storage_status || "").toLowerCase() === "unavailable") {
    return "unavailable";
  }

  const reportedStatus = String(dataQuality?.viewer_measurement_status || "").trim().toLowerCase();
  if (["missing", "measured_zero", "measured"].includes(reportedStatus)) {
    return reportedStatus;
  }

  if (dataQuality?.missing_viewer_snapshots === true) return "missing";

  const rows = Array.isArray(viewerRows) ? viewerRows : [];
  if (rows.length === 0) return "missing";

  return rows.some((row) => POSITIVE_VIEWER_MEASUREMENT_FIELDS.some(
    (field) => Number(row?.[field]) > 0,
  ))
    ? "measured"
    : "measured_zero";
};

export const buildStreamingParticipantExportMetadata = ({
  periodLabel,
  fetchedAtLabel,
  selectedRunLabel,
} = {}) => [
  {
    label: "Período do relatório",
    value: textValue(periodLabel, "Sem período registrado"),
  },
  {
    label: "Dados atualizados em",
    value: textValue(fetchedAtLabel, "Horário não informado"),
  },
  {
    label: "Escopo da seção",
    value: "Participantes cadastrados com presença confirmada na execução e no período do relatório; visitantes sem cadastro não são incluídos.",
  },
  {
    label: "Escopo de filtros",
    value: `Inclui todos os resultados após os filtros atuais de pesquisa e colunas, sem se limitar à página exibida. ${textValue(selectedRunLabel, "Execução selecionada")}.`,
  },
];
